import { render, staticRenderFns } from "./HistamineList.vue?vue&type=template&id=339a26da&"
import script from "./HistamineList.vue?vue&type=script&lang=js&"
export * from "./HistamineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports